<script>
import Form, { formCreate } from '../../../../../../components/form';
import request from '../../../../../../utils/request';
import { TableSelect, SelectProduct } from './components';
import Storage from '../../../../../../utils/storage';

formCreate.component('TableSelect', TableSelect);
formCreate.component('SelectProduct', SelectProduct);

export default {
  extends: Form,
  data() {
    return {
      rule: [],
      params: {},
      buttonText: {
        submit: '暂存',
        close: '关闭',
        submitAudit: '提交',
      },
      buttons: {
        submit: true,
        close: true,
        loading: false,
        submitAudit: true,
      },
      detailData: null,
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  async created() {
    await this.getDict();
  },
  async mounted() {
    this.rule = await this.getFormRule('terminal_orders_form', 'CRM20231122000000004');
    this.rule.map((v) => {
      const rowData = v;
      if (rowData.field === 'files') {
        rowData.props.showFileList = true;
        rowData.props.uploadType = 'file';
        rowData.props.listType = 'text';
        rowData.props.fileMsg = '只能上传pdf/word/excel/ppt/png/jpg文件';
        rowData.props.accept = '.pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,.png,.jpg';
        if (this.formConfig.code === 'view') {
          rowData.props.disabled = true;
        }
      }
      if (rowData.field === 'transitDealerName') {
        const paramsObj = {
          functionCode: 'select_ds_list',
          data: [],
          selectionList: [],
          idKey: 'customerCode',
          noReset: true,
          paramData: { enableStatus: '009' },
        };
        rowData.props = {
          ...rowData.props,
          paramsObj,
          placeholder: '大商名称',
        };
      }
      if (rowData.field === 'dealerName') {
        const paramsObj = {
          functionCode: 'select_distribut_list',
          data: [],
          selectionList: [],
          idKey: 'code',
          noReset: true,
          paramData: { enableStatus: '009' },
        };
        rowData.props = {
          ...rowData.props,
          paramsObj,
          placeholder: '分销商名称',
        };
      }
      if (rowData.field === 'detailedAddress') {
        const paramsObj = {
          functionCode: 'select_addr',
          data: [],
          selectionList: [],
          idKey: 'code',
          noReset: true,
          paramData: { enableStatus: '009' },
        };
        rowData.props = {
          ...rowData.props,
          paramsObj,
          placeholder: '收货地址',
        };
      }
      if (rowData.field === 'productInfo') {
        rowData.props = {
          functionCode: '',
          selection: [],
          idKey: 'id',
          notView: this.formConfig.code !== 'view',
          transitDealerCode: '',
        };
        rowData.value = [];
      }
      if (rowData.field === 'fileList') {
        console.log('rowData', rowData);
        rowData.props.showFileList = true;
        rowData.props.uploadType = 'file';
        rowData.props.fileSize = '100';
        rowData.props.listType = 'text';
        rowData.props.fileMsg = '只能上传pdf/word文件，且不超过100M';
        rowData.props.accept = '.pdf,.docx,.doc';
      }
      return rowData;
    });
    this.reload(this.rule);
    if (this.formConfig.row.id) {
      this.getData();
    }
  },
  methods: {
    // 获取数据字典
    getDict() {
      // 渠道
      request
        .post('/mdm/mdmdictdata/list', {
          dictTypeCode: 'jianfa_cust_code',
        })
        .then((res) => {
          if (!res.success) return this.$message.error(res.message);
          this.custList = res.result;
          Storage.l.set('custList', JSON.stringify(res.result));
        });
    },
    // 表单渲染完成后调用
    formComplete() {
      this.disabled(true, ['transitDelivery', 'paperOrderCode', 'returnMsg']);
      const productInfo = this.getRule('productInfo');
      const transitDealerName = this.getRule('transitDealerName');
      transitDealerName.on.change = (val) => {
        this.setValue({
          transitDealerName: val.customerName,
          transitDealerCode: val.customerCode,
        });
        this.params.transitDealerCode = val.customerCode;
        productInfo.props = {
          ...productInfo.props,
          transitDealerCode: val.customerCode,
          transitDealerName: val.customerName,
        };
      };
      const dealerName = this.getRule('dealerName');
      const detailedAddress = this.getRule('detailedAddress');
      dealerName.on.change = (val) => {
        this.setValue({
          dealerName: val.dealerName,
          dealerCode: val.dealerCode,
        });
        this.params.dealerCode = val.dealerCode;
        this.updateRules({
          detailedAddress: {
            props: {
              ...detailedAddress.props,
              paramsObj: {
                ...detailedAddress.props.paramsObj,
                paramData: { ...detailedAddress.props.paramsObj.paramData, dealerCode: val.dealerCode },
              },
            },
          },
        });
      };
      detailedAddress.on.change = (val) => {
        this.setValue({
          detailedAddress: val.detailedAddress,
          contactName: val.contactName,
          contactPhone: val.contactPhone,
        });
      };
    },
    // 获取表单数据
    getData() {
      let url = '';
      const params = {};
      if (this.formConfig.flag === 'audit') {
        url = '/dms/dmstransitorderdetail/querybyOrder';
        params.orderCode = this.formConfig.row.id;
      } else {
        url = '/dms/dmstransitorderdetail/query';
        params.id = this.formConfig.row.id;
      }
      request
        .post(url, params)
        .then((res) => {
          const productInfo = this.getRule('productInfo');
          productInfo.props = {
            ...productInfo.props,
            transitDealerCode: res.result.transitDealerCode,
            transitDealerName: res.result.transitDealerName,
          };
          const data = {
            ...res.result,
            image: res.result.images || [],
          };
          this.detailData = res.result;
          this.setValue(data);
        });
    },
    // 提交
    async submit(e) {
      const params = {
        ...this.getFormData(),
        ...this.params,
      };
      console.log(params);
      if (!params.image || !params.image.length) return false;
      if (!params.productInfo || !params.productInfo.length) return this.$message.error('请选择产品');
      if (!params.productInfo.some((item) => item.totalNum)) return this.$message.error('请输入产品数量');
      let inventoryQuantity = null;
      inventoryQuantity = this.custList.find((v) => v.dictCode === params.transitDealerCode);
      if (!inventoryQuantity) {
        params.productInfo = params.productInfo.map((v) => {
          const obj = v;
          obj.inventoryNum = 0;
          return obj;
        });
      }
      params.productInfo = params.productInfo.map((v) => {
        const obj = v;
        if (obj.inventoryNum === '系统未对接') {
          obj.inventoryNum = 0;
        }
        return obj;
      });
      let url = '/dms/transitOrder/saveTransit';
      if (e === 2) {
        if (this.formConfig.code === 'edit') {
          url = '/dms/transitOrder/updateTransit';
          params.orderCode = this.formConfig.row.orderCode;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      } else {
        url = '/dms/transitOrder/tsSaveTransit';
        if (this.formConfig.code === 'edit') {
          params.orderCode = this.formConfig.row.orderCode;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }

      return true;
    },
  },
};
</script>
